import useRegisterDiagnosticChecklist from "routes/home/my-courses/common/diagnostics/useRegisterDiagnosticChecklist.ts";
import {
  DiagnosticChecklist,
  DiagnosticChecklistItem,
} from "routes/home/my-courses/common/diagnostics/diagnosticChecklistTypes.ts";
import { ProgramDetailsType } from "routes/home/common/courses/buildProgramDetails.ts";
import {
  TermLite,
  useCoursesLoaderData,
  useProgramDetails,
} from "./coursesLoader.ts";

function buildChecklist({
  scope,
  userEffectiveProgram,
  allowsPrint,
  currentTerm,
}: Pick<
  ProgramDetailsType,
  "scope" | "userEffectiveProgram" | "allowsPrint"
> & {
  currentTerm: TermLite | undefined;
}): DiagnosticChecklist {
  const termItems: DiagnosticChecklistItem[] = currentTerm
    ? [
        {
          label: "Start date",
          status: "info",
          detail: [`startOn: ${currentTerm.startOn}`],
        },
        {
          label: "End date",
          status: "info",
          detail: [`endOn: ${currentTerm.endOn}`],
        },
        {
          label: "Opt-out deadline",
          status: "info",
          detail: [`optOutDeadlineDate: ${currentTerm.optOutDeadlineDate}`],
        },
        {
          label: "Allow opt-in after deadline",
          status: "info",
          detail: [
            `allowOptInAfterDeadline: ${currentTerm.allowOptInAfterDeadline}`,
          ],
        },
      ]
    : [
        {
          label: "Current term",
          status: "info",
          detail: ["No matched term selected"],
        },
      ];

  return {
    id: "term-info",
    title: "Term Info",
    items: [
      {
        label: "Program scope",
        status: "info",
        detail: [`scope: ${scope ?? "null"}`],
      },
      {
        label: "User effective program",
        status: "info",
        detail: [`userEffectiveProgram: ${userEffectiveProgram ?? "null"}`],
      },
      {
        label: "Allows print",
        status: "info",
        detail: [`allowsPrint: ${allowsPrint}`],
      },
      ...termItems,
    ],
  };
}

// Every value here is a raw pass-through from the same hooks that the page
// uses. The hook does not derive a value, so a diagnostic cannot disagree
// with the page.
export default function useTermInfoDiagnostics() {
  const { currentTerm } = useCoursesLoaderData();
  const { scope, userEffectiveProgram, allowsPrint } = useProgramDetails();

  useRegisterDiagnosticChecklist(
    buildChecklist({ scope, userEffectiveProgram, allowsPrint, currentTerm })
  );
}
